<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.combining",
                    :checked='params.combining',
                    @change='combiningHandler',
                    :disabled="combiningDisabled"
                )
        .settings__field(v-if="params.combining && !params.roundNumbers && !params.fractions")
            .settings__field-body
                combining-digit-capacity(
                    inner-component-name="settings-tab",
                    :filtered-combining-digit-capacities='filteredCombiningDigitCapacities',
                    :combining-digit-capacities='params.combiningDigitCapacities',
                    :combining-digit-capacity-labels='combiningDigitCapacityLabels',
                    @changeCombiningDigitCapacities='changeCombiningDigitCapacities'
                )
        .settings__field
            .settings__field-body
                settings-tab.settings__button(
                    :selected="params && params.negativeAnswers",
                    @click.native.prevent="params.negativeAnswers = !params.negativeAnswers"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
        .settings__field
            .settings__field-body
                settings-tab.settings__button(
                    :selected="params && params.fractions",
                    @click.native.prevent="fractionsHandler"
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
        .settings__field(v-if='params.fractions')
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
            .settings__field-body
                cs-select.settings__select(
                    :options="2"
                    v-model="params.fractionalPart"
                )
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples') }}:
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.infinityAmountOfExamples",
                    :checked="params && params.infinityAmountOfExamples",
                )
</template>

<script>
    /*eslint-disable*/
    import combiningCapacitiesMixin from "./../../games/utils/combiningCapacitiesMixin";
    import CombiningDigitCapacity from '../../games/shared/CombiningDigitCapacity.vue';

    export default {
        mixins: [combiningCapacitiesMixin],
        props: {
            currentUserParams: {
                type: Object,
                default () {
                    return null;
                }
            }
        },
        data () {
            return {
                params: null,
            }
        },
        watch: {
            currentUserParams: {
                handler (value) {
                    this.params = value;
                }
            },
            combiningDisabled (val) {
                if (val) {
                    this.params.combining = false;
                }
            }
        },
        methods: {
            combiningHandler (combining) {
                this.params.combining = combining;
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler () {
                this.params.fractions = !this.params.fractions;
                let value = this.params.fractions;
                if (value && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
        },
        computed: {
            combiningDisabled () {
                return this.params && this.params.difficult === 'Однозначные цифры';
            },
        },
        components: {
            CombiningDigitCapacity
        }
    }
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 40px 15px;
        @include media($xl) {
            padding: 25px 40px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: center;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__field-body {
        display: flex;
        align-items: center;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__select {
        width: 60px;
    }
</style>
